// Mock data for Calidad de Datos views – generates deterministic synthetic records

function seededRandom(seed) {
  const x = Math.sin(seed + 1) * 10000;
  return x - Math.floor(x);
}

function getISOWeek(dateStr) {
  const d = new Date(dateStr);
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + 3 - ((d.getDay() + 6) % 7));
  const week1 = new Date(d.getFullYear(), 0, 4);
  return 1 + Math.round(((d - week1) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7);
}

export const MOCK_OPERATORS = [
  { id: 1, nombre: "Chile TV Cable S.A." },
  { id: 2, nombre: "Telefónica Ch. S.A." },
  { id: 3, nombre: "Claro S.A." },
  { id: 4, nombre: "Electronet" },
  { id: 5, nombre: "GTD Manquehue" },
];

const OP_CONFIGS = [
  { id: 1, nombre: "Chile TV Cable S.A.", rbds: [3244, 3247, 3248], zona: 42, speedScale: 0.6 },
  { id: 2, nombre: "Telefónica Ch. S.A.", rbds: [4001, 4002, 4003], zona: 43, speedScale: 1.2 },
  { id: 3, nombre: "Claro S.A.", rbds: [5001, 5002, 5003], zona: 44, speedScale: 1.8 },
  { id: 4, nombre: "Electronet", rbds: [6001, 6002], zona: 45, speedScale: 0.9 },
  { id: 5, nombre: "GTD Manquehue", rbds: [7001, 7002], zona: 46, speedScale: 1.4 },
];

export const MOCK_ZONAS = Array.from({ length: 70 }, (_, i) => ({ id: i + 1, label: `Zona ${i + 1}` }));
export const MOCK_TECNOLOGIAS = [{ id: 9, label: "Fibra óptica" }];

function generateRecords() {
  const records = [];
  const MONTHS = [
    { year: 2026, month: 3, label: "2026-03", days: 31 },
  ];

  for (const { year, month, label, days } of MONTHS) {
    for (let d = 1; d <= days; d++) {
      const mm = String(month).padStart(2, "0");
      const dd = String(d).padStart(2, "0");
      const fecha = `${year}-${mm}-${dd}`;
      const dateObj = new Date(year, month - 1, d);
      const weekday = dateObj.getDay(); // 0=Sun, 6=Sat
      const isWeekend = weekday === 0 || weekday === 6;
      const semana = getISOWeek(fecha);

      for (const op of OP_CONFIGS) {
        for (const rbd of op.rbds) {
          const seed = op.id * 100000 + (rbd % 10000) * 10 + d;
          const r = (off = 0) => seededRandom(seed + off * 37);

          const baseLatencia = 25 + op.id * 8 + r(1) * 15;
          const baseBajada = 600000 * op.speedScale * (1 + r(2) * 0.4); // Bps
          const baseSubida = baseBajada * 0.1;
          const baseIntBajada = baseBajada * 0.65;
          const dayMult = 0.75 + r(3) * 0.5;

          const slotsTotal = 96;
          const slotsMissing = isWeekend ? 0 : Math.floor(r(4) * 6);
          const slotsInvalid = Math.floor(r(5) * 3);
          const slotsReported = slotsTotal - slotsMissing;
          const slotsVenTotal = isWeekend ? 0 : 48;
          const slotsVenMissing = isWeekend ? 0 : Math.floor(r(6) * 4);
          const slotsVenReported = slotsVenTotal - slotsVenMissing;

          // Helper: generate distribution stats
          const stats = (base, mult, std_pct, off_base) => {
            const mean = base * mult;
            const std = mean * std_pct;
            const noise = (off) => 1 + (r(off_base + off) * 0.4 - 0.2);
            return {
              mean: mean * noise(0),
              std: std * noise(1),
              min: Math.max(0, mean * 0.05 * noise(2)),
              p05: mean * 0.15 * noise(3),
              p25: mean * 0.65 * noise(4),
              p50: mean * 0.95 * noise(5),
              p75: mean * 1.2 * noise(6),
              p95: mean * 1.6 * noise(7),
              max: mean * (2.5 + r(off_base + 8) * 2),
            };
          };

          const lat = stats(baseLatencia, dayMult, 0.35, 10);
          const baj = stats(baseBajada, dayMult, 0.4, 20);
          const sub = stats(baseSubida, dayMult, 0.35, 30);
          const int_ = stats(baseIntBajada, dayMult, 0.4, 40);
          const paq = stats(r(50) * 2.5, 1, 0.5, 60);
          const latVen = stats(baseLatencia * (1 + r(70) * 0.15), dayMult, 0.35, 71);
          const bajVen = stats(baseBajada * (1 + r(80) * 0.2), dayMult, 0.4, 81);
          const subVen = stats(baseSubida * (1 + r(90) * 0.15), dayMult, 0.35, 91);
          const intVen = stats(baseIntBajada * (1 + r(100) * 0.2), dayMult, 0.4, 101);
          const paqVen = stats(r(110) * 3, 1, 0.5, 111);

          const perc_Dd = (slotsMissing / slotsTotal) * 100;
          const perc_Dp = r(120) * 1.5;

          records.push({
            fecha,
            rbd,
            id_operador: op.id,
            nombre_operador: op.nombre,
            id_zona: op.zona,
            tipo_tecnologia: 9,
            tipo_jornada: "A",
            anio_iso: year,
            semana_iso: semana,
            periodo: label,
            latencia_umbral: 100,
            vel_bajada: (baseBajada * 8) / 1e6,
            vel_subida: (baseSubida * 8) / 1e6,
            vel_bajada_int: (baseIntBajada * 8) / 1e6,
            subsidio: 50000 + rbd * 0.1,
            es_festivo: 0,
            slots_dia_total: slotsTotal,
            slots_dia_reportados: slotsReported,
            slots_dia_faltantes: slotsMissing,
            slots_dia_invalidos: slotsInvalid,
            slots_ven_total: slotsVenTotal,
            slots_ven_reportados: slotsVenReported,
            slots_ven_faltantes: slotsVenMissing,
            slots_ven_invalidos: Math.floor(r(7) * 2),
            // Latency dia
            latencia_dia_n_total: slotsTotal,
            latencia_dia_n_sentinela: slotsInvalid,
            latencia_dia_n_validos: slotsReported - slotsInvalid,
            latencia_dia_mean: lat.mean,
            latencia_dia_std: lat.std,
            latencia_dia_min: lat.min,
            latencia_dia_p05: lat.p05,
            latencia_dia_p25: lat.p25,
            latencia_dia_p50: lat.p50,
            latencia_dia_p75: lat.p75,
            latencia_dia_p95: lat.p95,
            latencia_dia_max: lat.max,
            // Latency ven
            latencia_ven_n_total: slotsVenTotal,
            latencia_ven_n_validos: slotsVenReported,
            latencia_ven_mean: slotsVenTotal ? latVen.mean : null,
            latencia_ven_std: slotsVenTotal ? latVen.std : null,
            latencia_ven_min: slotsVenTotal ? latVen.min : null,
            latencia_ven_p25: slotsVenTotal ? latVen.p25 : null,
            latencia_ven_p50: slotsVenTotal ? latVen.p50 : null,
            latencia_ven_p75: slotsVenTotal ? latVen.p75 : null,
            latencia_ven_p95: slotsVenTotal ? latVen.p95 : null,
            latencia_ven_max: slotsVenTotal ? latVen.max : null,
            // Bajada dia
            bajada_dia_n_total: slotsTotal,
            bajada_dia_n_validos: slotsReported - slotsInvalid,
            bajada_dia_mean: baj.mean,
            bajada_dia_std: baj.std,
            bajada_dia_min: baj.min,
            bajada_dia_p25: baj.p25,
            bajada_dia_p50: baj.p50,
            bajada_dia_p75: baj.p75,
            bajada_dia_p95: baj.p95,
            bajada_dia_max: baj.max,
            // Bajada ven
            bajada_ven_mean: slotsVenTotal ? bajVen.mean : null,
            bajada_ven_std: slotsVenTotal ? bajVen.std : null,
            bajada_ven_min: slotsVenTotal ? bajVen.min : null,
            bajada_ven_p25: slotsVenTotal ? bajVen.p25 : null,
            bajada_ven_p50: slotsVenTotal ? bajVen.p50 : null,
            bajada_ven_p75: slotsVenTotal ? bajVen.p75 : null,
            bajada_ven_max: slotsVenTotal ? bajVen.max : null,
            // Subida dia
            subida_dia_n_total: slotsTotal,
            subida_dia_n_validos: slotsReported - slotsInvalid,
            subida_dia_mean: sub.mean,
            subida_dia_std: sub.std,
            subida_dia_min: sub.min,
            subida_dia_p25: sub.p25,
            subida_dia_p50: sub.p50,
            subida_dia_p75: sub.p75,
            subida_dia_p95: sub.p95,
            subida_dia_max: sub.max,
            // Subida ven
            subida_ven_mean: slotsVenTotal ? subVen.mean : null,
            subida_ven_p25: slotsVenTotal ? subVen.p25 : null,
            subida_ven_p50: slotsVenTotal ? subVen.p50 : null,
            subida_ven_p75: slotsVenTotal ? subVen.p75 : null,
            subida_ven_min: slotsVenTotal ? subVen.min : null,
            subida_ven_max: slotsVenTotal ? subVen.max : null,
            // Internacional bajada dia
            interac_bajada_dia_mean: int_.mean,
            interac_bajada_dia_std: int_.std,
            interac_bajada_dia_min: int_.min,
            interac_bajada_dia_p25: int_.p25,
            interac_bajada_dia_p50: int_.p50,
            interac_bajada_dia_p75: int_.p75,
            interac_bajada_dia_p95: int_.p95,
            interac_bajada_dia_max: int_.max,
            // Internacional bajada ven
            interac_bajada_ven_mean: slotsVenTotal ? intVen.mean : null,
            interac_bajada_ven_p25: slotsVenTotal ? intVen.p25 : null,
            interac_bajada_ven_p50: slotsVenTotal ? intVen.p50 : null,
            interac_bajada_ven_p75: slotsVenTotal ? intVen.p75 : null,
            interac_bajada_ven_min: slotsVenTotal ? intVen.min : null,
            interac_bajada_ven_max: slotsVenTotal ? intVen.max : null,
            // Packet loss dia
            perdida_paquetes_dia_mean: paq.mean,
            perdida_paquetes_dia_std: paq.std,
            perdida_paquetes_dia_min: 0,
            perdida_paquetes_dia_p25: paq.p25,
            perdida_paquetes_dia_p50: paq.p50,
            perdida_paquetes_dia_p75: paq.p75,
            perdida_paquetes_dia_max: paq.max,
            // Packet loss ven
            perdida_paquetes_ven_mean: slotsVenTotal ? paqVen.mean : null,
            perdida_paquetes_ven_p25: slotsVenTotal ? paqVen.p25 : null,
            perdida_paquetes_ven_p50: slotsVenTotal ? paqVen.p50 : null,
            perdida_paquetes_ven_p75: slotsVenTotal ? paqVen.p75 : null,
            perdida_paquetes_ven_min: slotsVenTotal ? 0 : null,
            perdida_paquetes_ven_max: slotsVenTotal ? paqVen.max : null,
            // Descuentos
            slots_Dprop: 0,
            perc_Dprop: 0,
            slots_Dd: slotsMissing,
            perc_Dd,
            slots_Dl: 0,
            perc_Dl: 0,
            slots_Dp: Math.floor(r(121) * 2),
            perc_Dp,
          });
        }
      }
    }
  }
  return records;
}

export const MOCK_DATA = generateRecords();

// API-style functions (swap with real API calls when ready)
export function fetchCalidadDatos({ periodos = [], operadores = [], zonas = [], rbds = [], tecnologias = [] } = {}) {
  let rows = MOCK_DATA;
  if (periodos.length) rows = rows.filter((r) => periodos.includes(r.periodo));
  if (operadores.length) rows = rows.filter((r) => operadores.includes(r.id_operador));
  if (zonas.length) rows = rows.filter((r) => zonas.includes(r.id_zona));
  if (rbds.length) rows = rows.filter((r) => rbds.includes(r.rbd));
  if (tecnologias.length) rows = rows.filter((r) => tecnologias.includes(r.tipo_tecnologia));
  return Promise.resolve(rows);
}
